// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	FireInsuranceBrokerageNameAutoComplete:
		'fire-insurance-brokerage-name-auto-complete',
	FireInsuranceBrokerageItemDiv: 'fire-insurance-brokerage-item-div',
	CreateBrokerageButton: 'create-brokerage-button',
} as const;
